import React from "react";
import {BenefitsCard, BenefitsType} from "./index";
import {va} from "../../../utils/commonUtils";


type MyBenefitsPageProps = {
    responseData: any;
    isIul?: boolean;
};


const MyBenefitsPage: React.FC<MyBenefitsPageProps> = ({responseData, isIul}) => {
    const illustration = responseData && responseData.illustration ? responseData.illustration : {totalincome: 0};
    const illustrationTables = (illustration && illustration.data && illustration.data.table) || [];
    const table0PremiumPaid = illustrationTables && va(illustrationTables) && illustrationTables[0];
    const targetAgeCashSurrender = responseData && responseData.common && responseData.common.incomeagefrom - 1;
    const targetAgeDB = 95;
    const foundCashSurrender = illustrationTables.find((r: { age: number; }) => r.age === targetAgeCashSurrender);
    const foundDeathBenefit = illustrationTables.find((r: { age: number; }) => r.age === targetAgeDB);
    const [
        cashSurrender,
        deathbenefit,
        premiumPaid
    ] = [
        foundCashSurrender ? foundCashSurrender.cashsurrender : 0,
        foundDeathBenefit? foundDeathBenefit.deathbenefit : 0,
        table0PremiumPaid ? table0PremiumPaid.premiumpaid : 0,
    ];
    const getTitle = () => {
        // if isIul is true
        if (isIul) {
            return "Your Estimated IUL Benefits";
        }
        return "Your Estimated Kaizen Benefits";
    }

    const estimatedBenefits: BenefitsType = {
        title: getTitle(),
        items: [
            {label: "Annual Premium Payment", value: premiumPaid},
            {label: "Total Cash Value (at age 64)", value: cashSurrender},
            {label: "Total Retirement Income (from age 64-90)", value: illustration.totalincome},
            {label: "Death Benefit (at age 95)", value: deathbenefit},
        ],
    };

    return (
            <BenefitsCard benefits={estimatedBenefits.items} title={estimatedBenefits.title}/>
    );
};

export default MyBenefitsPage;
